import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    text: {
        fontSize: '1.125rem',
        lineHeight: 1.2,
        fontWeight: 'normal',
    },
});
